import { FC } from 'react'
import { useTranslation } from 'react-i18next'
// import { RiCheckboxCircleFill, RiInformationFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'

import ImagePaths from '../../../utils/constants/ImagePaths'
import { StyledBiddingAnnoucement, StyledBiddingAnnoucementImage } from './BiddingAnnoucement.style'

interface BiddingAnnoucementProps extends LibraryComponentType {
  warning?: boolean
}

const BiddingAnnoucement: FC<BiddingAnnoucementProps> = ({ onClose, warning }) => {
  const { t } = useTranslation()

  return (
    <StyledBiddingAnnoucement>
      <StyledBiddingAnnoucementImage>
        <img src={ImagePaths.bidding['annoucement-modal-bg']} />
        <img src={ImagePaths.bidding['annoucement-modal-icon']} />
      </StyledBiddingAnnoucementImage>
      <b>{t('bidding.annoucementModal.title')}</b>
      <p>{t('bidding.annoucementModal.desc')}</p>
    </StyledBiddingAnnoucement>
  )
}

export default BiddingAnnoucement
